import React, { useEffect } from 'react'
import { Category } from 'enums'
import { createInsightCount } from 'utils/runSearchUtil'
import { useAppDispatch } from 'app/hooks'
import { getInsightContentData } from 'features/insightContent/asyncThunks'
import { InsightContentSettingType } from 'components/insightContent/types'
import { Filter } from 'schemas/FilterSchema'
import { RichMentionedUrl } from 'schemas/RichMentionedUrlSchema'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'
import TopAuthorsType, {
  TopAuthorsTypeStrings
} from 'components/insightContent/enum/TopAuthorsType'

const SIZE_NEEDED = 10
const SORT_BY = 'FollowersNoMeasure'

const createSearch = (
  detailSetting: InsightContentSettingType,
  postType?: TopAuthorsTypeStrings
) => {
  if (detailSetting.selectionFilter) {
    if (detailSetting?.selectionFilter?.includedPosts?.[0]?.length === 0) {
      return null
    }

    const filter = {
      parentDocIds: detailSetting.selectionFilter.parentDocIds || null,
      mentionedUrls: detailSetting.selectionFilter.mentionedUrls || ([] as RichMentionedUrl[])
    } as Filter

    if (postType === TopAuthorsType.REPLIES || postType === TopAuthorsType.REPOSTS) {
      filter.postTypeGroups = [postType]
    }

    const option = {
      sizeNeeded: SIZE_NEEDED
    }

    return createInsightCount(
      -1,
      '',
      detailSetting.precision,
      [detailSetting.topicId],
      filter,
      SORT_BY,
      [Category.AUTHORS],
      option
    )
  }
  return null
}

const RunSearchEffect = ({
  detailSetting,
  postType,
  children
}: {
  detailSetting: InsightContentSettingType
  children: React.ReactNode
  postType: TopAuthorsTypeStrings
}) => {
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp()

  useEffect(() => {
    const searches = createSearch(detailSetting, postType)

    dispatch(
      getInsightContentData({
        insightContentType: postType,
        searches: [searches!],
        timestamp: refreshTimestamp
      })
    )
  }, [dispatch, detailSetting, postType, refreshTimestamp])

  return <>{children}</>
}

export default RunSearchEffect
